
let url = 'https://api.dev.gdteacher.com';
if (process.env.NODE_ENV === 'development') {
  url = 'https://api.dev.gdteacher.com';
} else if (process.env.NODE_ENV === 'test') {
  url = 'https://api.test.gdteacher.com';
} else if (process.env.NODE_ENV === 'production') {
  url = 'https://api.ttcn.cn';
} else if (process.env.NODE_ENV === 'release') {
  url = 'https://api.ttcn.cn';
}
export const apis = {
  api: {
    video: {
      getMediaIdByOssUrl: url+'/studyService/video/video-videoinfo/getMediaIdByOssUrl',    //根据oss地址获取媒体id
      getMappingSdPathUrl: url+'/studyService/video/oss-sd-mapping/getNewOssPath',  // 老的历史的作业上传视频，获取历史的转码的地址
      getMediaWorkflowExecutionByRunId: url+'/studyService/video/video-videoinfo/getMediaWorkflowExecutionByRunId',    //获取转码进度
      getPlayerParamByMediaId: url+'/studyService/video/video-videoinfo/getPlayerParamByMediaId',    //根据媒体id获取阿里播放参数
      fileGzeduUpload: 'https://file.gzteacher.com/apiUpload/shareUrl.do',  //天翼云根据uploadInfoId查找原始地址
    },
    system:{
      getAPPInfo: url + '/baseData/app-info/search', //获取应用信息
      checkToken: url + '/oauthService/checkToken/',
      period: url + '/baseData/basecode/findCodeByTypeCode',//学段
      subject: url + '/baseData/basecode/subject/getSubjectBySection/',//学科
      getCodeImage: url + '/captcha/imageUrl', //获取图形验证码
      token:url+'/oauthService/teacher/login',
    },
    user:{
      login:url+'/oauthService/oauth/token',
      getCodeImage: url + '/captcha/imageUrl', //获取图形验证码
      imageUrl:url+'/captcha/imageUrl',
      checkGroupLeader:url+'/trainService/workshop/checkGroupLeader',   //检验身份
    },
    home:{
      getCourseList: url+'/tsgc2Service/tsgc/course-example-view/search', //课例观摩分页列表
      abilityTrain: url+'/tsgc2Service/tsgc/ability-train/search',  //微能力培训列表
      getMicroList: url+'/tsgc2Service/micro-ability/getMicroList', //微能力培训列表1
      baseServer: url + '/baseData',
      courseExampleView: url+'/tsgc2Service/tsgc/course-example-view/search',  //课例观摩分页列表
      courseExample: url+'/tsgc2Service/tsgc/course-example-view', //根据id获取课例观摩的信息
      solveCourse: url+'/tsgc2Service/tsgc/solve-course/',  //保存解课提交的信息
      solveCourseSearch: url+'/tsgc2Service/tsgc/solve-course/search', //获取课例观摩也解课页面视频下方的解课列表接口
      getMicroAbilityAuthenResult: url+'/tsgc2Service/micro-ability/getMicroAbilityAuthenResult', //获取微能力认证情况列表
    }
  }
};

